import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import domtoimage from 'dom-to-image'
import { SketchPicker } from 'react-color'
import {
  loadLessonDetail,
  deleteLesson,
  clearLessonDetail,
  addFavoriteLesson,
} from '../../common/lessons/actions'
import { OptionsForm, TranslationForm } from '../forms'
import { roles, exerciseTypes } from '../../common/config'
import Logo from '../components/Logo'
import PageHeader from '../components/PageHeader'
import WordboxDetail from '../components/WordboxDetail'
import Button from '../components/Button'
import BackLink from '../components/BackLink'
import TextInput from '../components/fields/TextInput'


class LessonInstagramPage extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();

    this.bgPath = '/assets/images/instagram-templates/'
    this.bgImages = [
      'instagram-bg.jpg',
      'french.jpg',
      'czenglisher-vocabulary.jpg',
      'gib-vocabulary.jpg',
    ]

    this.state = {
      color: 'rgba(0, 72, 124, 1)',
      wordsPerImage: 1,
      currentBgImage: "instagram-bg.jpg",
    }
  }

  componentWillMount() {
    const { loadLessonDetail, match } = this.props
    if (match && match.params.id) {
      loadLessonDetail(match.params.id)
    }
  }

  componentDidCatch(error, info) {
    console.log('error - LessonInstagramPage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentWillUnmount() {
    this.props.clearLessonDetail()
  }

  renderImage() {
    const { currentLesson } = this.props
    const { words } = currentLesson

    if (currentLesson.type === exerciseTypes.WORDBOX) {
      const instagramPreviewEl = document.querySelector('#instagram-wordbox-preview')

      domtoimage.toJpeg(instagramPreviewEl)
          .then(function (dataUrl) {
              var img = new Image()
              img.src = dataUrl
  
              const a = document.createElement('a')
              document.body.appendChild(a)
              a.download = `${currentLesson.name}.jpg`
              a.href =  dataUrl
              a.click()
          })
          .catch(function (error) {
              console.error('Error, while creating image!', error)
          })

    } else {
      words.map((word, idx) => {
        const instagramPreviewEl = document.querySelector(`#instagram-image-preview-${idx}`)
  
        domtoimage.toJpeg(instagramPreviewEl)
          .then(function (dataUrl) {
              var img = new Image()
              img.src = dataUrl
  
              const a = document.createElement('a')
              document.body.appendChild(a)
              a.download = `${word.foreignWord}.jpg`
              a.href =  dataUrl
              a.click()
              // document.body.appendChild(img)
          })
          .catch(function (error) {
              console.error('Error, while creating image!', error)
          })
      })
    }
  }

  setBg(bg) {
    this.setState({ currentBgImage: bg })
  }

  handleChangeComplete = (color) => {
    this.setState({ color: color.hex });
  }

  render() {
    const { viewer, currentLesson, isPopup,
      clearLessonDetail, intl } = this.props

    const { currentBgImage, wordsPerImage, color } = this.state

    if (!currentLesson) return null

    return (
      <div className={isPopup ? '' : 'page'}>
        <div className="flex-column width-full">
          {
            isPopup ?
              <header>
                <div
                  className="popup-wrapper-close"
                  onClick={() => clearLessonDetail()}
                >
                  <FontAwesomeIcon icon="times-circle" size="2x" />
                </div>
              </header>
            :
              <BackLink />
          }
          <div className={isPopup ? 'popup-content-body' : 'width-full'}>
            <PageHeader
              title={`${intl.formatMessage(messages.exercise)}: ${currentLesson.name}`}
              share={`https://vobo.io/lessons/${currentLesson.id}`}
            />
            {
              currentLesson.type === exerciseTypes.OPTIONS &&
              <OptionsForm
                lesson={currentLesson}
                isDetailPage
              />
            }
            {
              currentLesson.type === exerciseTypes.TRANSLATION &&
              <React.Fragment>
                <TranslationForm
                  lesson={currentLesson}
                  isDetailPage
                />
                <div className="instagram-image">
                  <TextInput
                    label="Words per image"
                    value={wordsPerImage}
                    onChange={({ target }) => this.setState({ wordsPerImage: target.value })}
                  />
                  <div className="row background-options">
                    {this.bgImages.map(bgImage => (
                      <img
                        key={bgImage}
                        className={currentBgImage === bgImage ? 'active': ''}
                        src={`${this.bgPath}${bgImage}`} 
                        onClick={() => this.setBg(bgImage)}
                      />
                    ))}
                  </div>
                  <div className="font-color">
                    <h3>Text color:</h3>
                    <SketchPicker
                      color={ this.state.color }
                      onChangeComplete={ this.handleChangeComplete }
                    />
                  </div>
                  {
                    currentLesson.words.map((word, idx) => (
                      <div
                        key={`instagram-image-preview-${idx}`}
                        id={`instagram-image-preview-${idx}`}
                        className="instagram-image-preview"
                        style={{
                          backgroundImage: `url(${this.bgPath}${currentBgImage})`,
                          color: color,
                        }}
                      >
                        <p style={{ color: color }} className="foreign">
                          {word.foreignWord}
                        </p>
                        <p style={{ color: color }} className="base">
                          {word.baseWord}
                        </p>
                      </div>
                    ))
                  }
                </div>
              </React.Fragment>
            }
            <div onClick={() => this.renderImage()}>
              <Button
                positive
                className="spacing-top disable-spacing-left"
              >
                Render image
              </Button>
            </div>
            {
              currentLesson.type === exerciseTypes.WORDBOX &&
              <div id="instagram-wordbox-preview">
                <Logo size="large"/>
                <h1>{currentLesson.name}</h1>
                <WordboxDetail
                  lesson={currentLesson}
                  isDetailPage
                />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

LessonInstagramPage.defaultProps = {
  currentLesson: null,
  match: null,
  viewer: null,
  isPopup: false,
}

LessonInstagramPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadLessonDetail: PropTypes.func.isRequired,
  deleteLesson: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  addFavoriteLesson: PropTypes.func.isRequired,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  viewer: PropTypes.object,
  isPopup: PropTypes.bool,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
  }), { loadLessonDetail, deleteLesson, clearLessonDetail, addFavoriteLesson }),
  injectIntl,
)

export default enhance(LessonInstagramPage)

const messages = defineMessages({
  exercise: {
    id: 'lessonDetail.page.exercise',
    defaultMessage: 'Cvičenie',
  },
  study: {
    id: 'lessonDetail.page.study',
    defaultMessage: 'Učiť sa',
  },
  test: {
    id: 'lessonDetail.page.test',
    defaultMessage: 'Test',
  },
  memoryGame: {
    id: 'lessonDetail.page.memoryGame',
    defaultMessage: 'Pexeso',
  },
  print: {
    id: 'lessonDetail.page.print',
    defaultMessage: 'Vytlačiť',
  },
  learnAccess: {
    id: 'lessonDetail.page.learnAccess',
    defaultMessage: 'Žiaci sa môžu učiť slovíčka na tejto adrese',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/LessonInstagramPage.js